import type { AvatarManifest } from './rig';

/** Structural checks only: visual motion quality still needs a preview. */
export function avatarReadiness(manifest: AvatarManifest) {
  const c = manifest.capabilities;
  return {
    version: 1,
    body: c.bodyMapped && c.armIKCandidate && c.footIKCandidate,
    blink: c.blink,
    mouth: c.jaw,
    expressions: Boolean(manifest.face.smile?.length || manifest.face.smileLeft?.length || manifest.face.smileRight?.length),
    needsFacialPreparation: !c.blink || !c.jaw,
  };
}
export type AvatarReadiness = ReturnType<typeof avatarReadiness>;
